<bv-dialog
  [open]="open"
  [closeOnBackdrop]="false"
  [closeOnEscape]="false"
  >
  <bv-dialog-title>{{ "PAPER_SIZE_TITLE" | translate }}</bv-dialog-title>
  <bv-dialog-body>
    <p class="paper-size-body">
      @if (deviceName) {
        {{ "PAPER_SIZE_BODY_NAMED" | translate: { name: deviceName } }}
      }
      @if (!deviceName) {
        {{ "PAPER_SIZE_BODY" | translate }}
      }
    </p>
    <bv-radio-group [(ngModel)]="selected">
      <bv-radio value="80mm">{{ "PAPER_SIZE_80MM" | translate }}</bv-radio>
      <bv-radio value="58mm">{{ "PAPER_SIZE_58MM" | translate }}</bv-radio>
    </bv-radio-group>
  </bv-dialog-body>
  <bv-dialog-footer>
    <button bv-button variant="primary" (click)="confirm()">
      {{ "OK" | translate }}
    </button>
  </bv-dialog-footer>
</bv-dialog>
